import React from 'react';
import LazyLoad from 'react-lazyload';
import { Container, Row, Col } from "react-bootstrap";
import { MdLocationOn } from "react-icons/md";
function CollectionInnerLocation({ location }) {

    return (
        <section className='collection-inner-location-sec'>
            <Container fluid>
                <Row className='flex-center'>
                    <Col md={12}>
                        <div className='construction-location-sec'>

                            <Row className=' '>
                                <Col md={12}>
                                    <div className='heading-div'>
                                        <h2 className='common-head darkGrey' data-aos="fade-up">{location.title} <MdLocationOn className='goldenColor' /> </h2>
                                    </div>
                                    <iframe src={`${location.property_location}`} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-aos="fade-up"></iframe>


                                </Col>
                            </Row>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default CollectionInnerLocation;